export default {
  title: 'Menü-Änderungsverlauf',
  subtitle: 'Sehen Sie, wer Preise, Verfügbarkeit und Sichtbarkeit für {{company}} geändert hat – und wann.',
  filters: {
    type: {
      label: 'Typ',
    },
    item: {
      placeholder: 'Alle Artikel',
    },
    event: {
      label: 'Ereignis',
    },
  },
  columns: {
    when: 'Wann',
    who: 'Geändert von',
    type: 'Typ',
    item: 'Artikel',
    event: 'Ereignis',
    changes: 'Änderungen',
  },
  types: {
    product: 'Produkt',
    modifier: 'Zusatz',
  },
  events: {
    created: 'Erstellt',
    updated: 'Aktualisiert',
    deleted: 'Gelöscht',
  },
  fields: {
    name: 'Name',
    description: 'Beschreibung',
    price: 'Preis',
    is_available: 'Verfügbarkeit',
    is_visible: 'Sichtbarkeit',
    is_available_for_pickup: 'Verfügbarkeit Abholung',
    is_available_for_delivery: 'Verfügbarkeit Lieferung',
  },
  booleans: {
    on: 'Verfügbar',
    off: 'Nicht verfügbar',
  },
  pagination: {
    previous: 'Zurück',
    next: 'Weiter',
  },
  causers: {
    orders_terminal: 'Bestellterminal',
  },
  system: 'System',
  empty_value: '—',
  toasts: {
    failed_to_load_data: 'Menü-Änderungsverlauf konnte nicht geladen werden',
  },
};
